export interface Comic {
  id: string;
  title: string;
  type: 'guoman' | 'riman';
  genres: string[];
  status: '连载中' | '已完结';
  chapters: number;
  rating: number;
  views: string;
  year: number;
  cover: string;
  intro: string;
  tag?: string;
}

export const guomanComics: Comic[] = [
  {
    id: 'shanhai',
    title: '山海异兽录',
    type: 'guoman',
    genres: ['玄幻', '神话', '热血'],
    status: '连载中',
    chapters: 328,
    rating: 9.6,
    views: '2.1亿',
    year: 2021,
    tag: '榜首',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20Chinese%20mythology%20manhua%20cover%2C%20young%20hero%20standing%20with%20a%20divine%20beast%20companion%2C%20floating%20mountains%20and%20clouds%20behind%2C%20golden%20and%20teal%20color%20palette%2C%20dynamic%20ink%20painting%20style%2C%20dramatic%20lighting%2C%20epic%20poster%20art%20illustration&width=600&height=800&seq=cover-gm-shanhai&orientation=portrait',
    intro: '上古山海崩塌，异兽重现人间。少年闻人戟背负神兽蛋踏遍九州，在神话与凡尘之间，追寻身世与拯救苍生的真相。',
  },
  {
    id: 'changan',
    title: '长安十二时局',
    type: 'guoman',
    genres: ['古风', '权谋', '悬疑'],
    status: '连载中',
    chapters: 156,
    rating: 9.4,
    views: '9800万',
    year: 2022,
    tag: '口碑',
    cover: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20court%20drama%20manhua%20cover%2C%20elegant%20robed%20official%20in%20a%20grand%20palace%20hall%2C%20glowing%20lanterns%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20painterly%20detail%2C%20suspenseful%20atmosphere&width=600&height=800&seq=cover-gm-changan&orientation=portrait',
    intro: '一座长安城，十二时辰里暗流涌动。新科探花郎身陷朝廷棋局，步步惊心，层层反转，揭开盛世之下的惊天秘闻。',
  },
  {
    id: 'xia',
    title: '侠隐长安',
    type: 'guoman',
    genres: ['武侠', '热血', '古风'],
    status: '已完结',
    chapters: 420,
    rating: 9.7,
    views: '3.4亿',
    year: 2019,
    cover: 'https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20manhua%20cover%2C%20hooded%20swordsman%20standing%20on%20a%20rooftop%20at%20dusk%20over%20an%20ancient%20city%2C%20deep%20orange%20sky%2C%20dynamic%20pose%2C%20cinematic%20lighting%2C%20detailed%20illustration&width=600&height=800&seq=cover-gm-xia&orientation=portrait',
    intro: '江湖恩怨，侠隐于市。一把无名之剑，一段家国大义，在刀光剑影中看尽长安浮沉，终成一代传奇。',
  },
  {
    id: 'lingqi',
    title: '灵气复苏：我成了宗门大佬',
    type: 'guoman',
    genres: ['都市', '修仙', '搞笑'],
    status: '连载中',
    chapters: 268,
    rating: 9.2,
    views: '1.6亿',
    year: 2023,
    tag: '新作',
    cover: 'https://readdy.ai/api/search-image?query=modern%20urban%20cultivation%20manhua%20cover%2C%20stylish%20young%20cultivator%20with%20glowing%20spiritual%20energy%2C%20city%20skyline%20backdrop%2C%20teal%20and%20orange%20neon%20tones%2C%20energetic%20poster%20art&width=600&height=800&seq=cover-gm-lingqi&orientation=portrait',
    intro: '灵气复苏时代来临，普通上班族误入修真宗门。从扫地杂役到宗门大佬，一边修仙一边摸鱼，搞笑又热血的都市修仙日常。',
  },
  {
    id: 'shiguang',
    title: '时光代理人·新篇',
    type: 'guoman',
    genres: ['都市', '奇幻', '悬疑'],
    status: '连载中',
    chapters: 88,
    rating: 9.5,
    views: '7200万',
    year: 2024,
    tag: '热播',
    cover: 'https://readdy.ai/api/search-image?query=urban%20fantasy%20time%20travel%20manhua%20cover%2C%20two%20stylish%20agents%20with%20a%20glowing%20pocket%20watch%2C%20neon%20city%20night%2C%20cool%20teal%20and%20warm%20gold%20contrast%2C%20anime%20poster%20art&width=600&height=800&seq=cover-gm-shiguang&orientation=portrait',
    intro: '时光代理人承接委托，穿越过去改写命运。这一次，他们卷入一桩横跨十年的悬案，在时间线上与真相赛跑。',
  },
  {
    id: 'saibo',
    title: '赛博镖局',
    type: 'guoman',
    genres: ['科幻', '热血', '冒险'],
    status: '连载中',
    chapters: 112,
    rating: 9.3,
    views: '8600万',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=cyberpunk%20Chinese%20wuxia%20fusion%20manhua%20cover%2C%20armored%20courier%20with%20a%20glowing%20blade%20in%20a%20neon%20alley%2C%20teal%20and%20crimson%20lights%2C%20high%20detail%20action%20poster&width=600&height=800&seq=cover-gm-saibo&orientation=portrait',
    intro: '霓虹废土之上，古老镖局改行押送数据与机械秘宝。新一代镖师持刃穿行于赛博都市，在秩序与混乱间走出自己的侠道。',
  },
  {
    id: 'chushen',
    title: '厨神小当仙',
    type: 'guoman',
    genres: ['美食', '搞笑', '热血'],
    status: '已完结',
    chapters: 210,
    rating: 9.1,
    views: '5400万',
    year: 2020,
    cover: 'https://readdy.ai/api/search-image?query=chinese%20cuisine%20cooking%20manhua%20cover%2C%20cheerful%20young%20chef%20holding%20a%20steaming%20wok%20with%20delicious%20dishes%20around%2C%20warm%20golden%20tones%2C%20appetizing%20vibrant%20illustration&width=600&height=800&seq=cover-gm-chushen&orientation=portrait',
    intro: '凡尘小厨误入仙门，凭一手人间烟火味走遍仙凡两界。吃出境界，做出传奇，一场关于味道与梦想的美食冒险。',
  },
  {
    id: 'lianlian',
    title: '恋恋手工社',
    type: 'guoman',
    genres: ['恋爱', '校园', '治愈'],
    status: '连载中',
    chapters: 64,
    rating: 9.0,
    views: '4100万',
    year: 2024,
    cover: 'https://readdy.ai/api/search-image?query=cute%20school%20romance%20manhua%20cover%2C%20shy%20girl%20and%20boy%20in%20an%20art%20club%20studio%2C%20pastel%20warm%20colors%2C%20soft%20lighting%2C%20wholesome%20anime%20style&width=600&height=800&seq=cover-gm-lianlian&orientation=portrait',
    intro: '手工社里，针线串起的心事渐渐明了。害羞的少女与笨拙的少年，在一针一线之间，编织出青春里最温柔的故事。',
  },
];

export const rimanComics: Comic[] = [
  {
    id: 'yunhai',
    title: '云海之城的魔法使',
    type: 'riman',
    genres: ['奇幻', '冒险', '热血'],
    status: '连载中',
    chapters: 96,
    rating: 9.5,
    views: '1.2亿',
    year: 2022,
    tag: '热播',
    cover: 'https://readdy.ai/api/search-image?query=fantasy%20japanese%20manga%20cover%2C%20young%20mage%20with%20a%20staff%20overlooking%20a%20floating%20cloud%20city%2C%20warm%20sunset%20and%20teal%20sky%2C%20epic%20fantasy%20poster%20art&width=600&height=800&seq=cover-rm-yunhai&orientation=portrait',
    intro: '漂浮在云海之上的魔法城邦，正被古老诅咒悄然侵蚀。见习魔法使亚莉丝踏上救世之旅，探寻魔力与记忆的真相。',
  },
  {
    id: 'yinyi',
    title: '银翼猎手',
    type: 'riman',
    genres: ['科幻', '热血', '动作'],
    status: '连载中',
    chapters: 142,
    rating: 9.3,
    views: '9400万',
    year: 2021,
    tag: '高燃',
    cover: 'https://readdy.ai/api/search-image?query=sci-fi%20action%20manga%20cover%2C%20agile%20pilot%20with%20a%20silver%20wing%20jetpack%2C%20dramatic%20crimson%20and%20steel%20palette%2C%20explosive%20action%2C%20manga%20poster&width=600&height=800&seq=cover-rm-yinyi&orientation=portrait',
    intro: '天空猎手以银翼驰骋云端，追猎失控机械与危险造物。赏金、荣耀与宿命交织，一场高燃的空战冒险就此展开。',
  },
  {
    id: 'shenye',
    title: '深夜食堂物语',
    type: 'riman',
    genres: ['治愈', '美食', '日常'],
    status: '已完结',
    chapters: 120,
    rating: 9.7,
    views: '1.8亿',
    year: 2018,
    cover: 'https://readdy.ai/api/search-image?query=cozy%20japanese%20izakaya%20manga%20cover%2C%20warm%20lantern%20lit%20small%20restaurant%20at%20night%2C%20steaming%20comfort%20food%2C%20warm%20amber%20tones%2C%20gentle%20and%20healing%20mood&width=600&height=800&seq=cover-rm-shenye&orientation=portrait',
    intro: '巷子深处的小馆子，只在深夜开门。一碗热汤、一盘小菜，听尽往来客人的悲欢故事，在烟火气里治愈每一颗疲惫的心。',
  },
  {
    id: 'jianzhou',
    title: '剑与咒',
    type: 'riman',
    genres: ['冒险', '奇幻', '热血'],
    status: '连载中',
    chapters: 208,
    rating: 9.4,
    views: '2.6亿',
    year: 2020,
    tag: '经典',
    cover: 'https://readdy.ai/api/search-image?query=fantasy%20adventure%20manga%20cover%2C%20young%20swordsman%20and%20a%20mysterious%20ally%20on%20an%20ancient%20forest%20road%2C%20golden%20hour%20light%2C%20teal%20foliage%2C%20epic%20journey%20mood&width=600&height=800&seq=cover-rm-jianzhou&orientation=portrait',
    intro: '诅咒侵蚀大陆，剑士与咒术师结伴同行。一人执剑破敌，一人以咒缚命，在旅途尽头直面世界的终极秘密。',
  },
  {
    id: 'xingchen',
    title: '星尘学院',
    type: 'riman',
    genres: ['校园', '青春', '搞笑'],
    status: '连载中',
    chapters: 76,
    rating: 8.9,
    views: '3900万',
    year: 2024,
    cover: 'https://readdy.ai/api/search-image?query=energetic%20high%20school%20manga%20cover%2C%20cheerful%20students%20in%20warm%20sunlight%20by%20the%20school%20gate%2C%20coral%20and%20cream%20palette%2C%20lively%20and%20fresh&width=600&height=800&seq=cover-rm-xingchen&orientation=portrait',
    intro: '星尘学院里，一群热血少年少女的青春日常。社团、比赛、友情与梦想，在闪闪发光的校园时光里肆意生长。',
  },
  {
    id: 'jixie',
    title: '机械之心',
    type: 'riman',
    genres: ['科幻', '机战', '热血'],
    status: '已完结',
    chapters: 320,
    rating: 9.6,
    views: '2.9亿',
    year: 2017,
    cover: 'https://readdy.ai/api/search-image?query=mecha%20action%20manga%20cover%2C%20giant%20battle%20robot%20with%20a%20glowing%20core%2C%20dusk%20battlefield%2C%20orange%20and%20steel%20tones%2C%20dramatic%20scale%20poster&width=600&height=800&seq=cover-rm-jixie&orientation=portrait',
    intro: '战争之末，最后一台残破机体与少年驾驶员相遇。钢铁与人心的羁绊，在一次次战斗中铸成无可替代的机械之心。',
  },
  {
    id: 'yaoguai',
    title: '妖怪街的日常',
    type: 'riman',
    genres: ['治愈', '日常', '搞笑'],
    status: '连载中',
    chapters: 58,
    rating: 9.2,
    views: '3300万',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=gentle%20daily%20life%20manga%20cover%20with%20cute%20yokai%20spirits%20in%20a%20traditional%20japanese%20street%2C%20warm%20evening%20lanterns%2C%20soft%20and%20charming%20illustration&width=600&height=800&seq=cover-rm-yaoguai&orientation=portrait',
    intro: '一条住满妖怪的小街，藏着人间烟火与妖怪趣事。温柔的妖怪们与寻常邻居的日常，好笑又暖心的治愈篇章。',
  },
  {
    id: 'tianpin',
    title: '甜品侦探',
    type: 'riman',
    genres: ['悬疑', '推理', '治愈'],
    status: '连载中',
    chapters: 44,
    rating: 9.1,
    views: '2100万',
    year: 2024,
    cover: 'https://readdy.ai/api/search-image?query=cozy%20mystery%20manga%20cover%2C%20young%20detective%20holding%20a%20macaron%20in%20a%20charming%20patisserie%2C%20warm%20cream%20and%20rose%20tones%2C%20soft%20and%20intriguing&width=600&height=800&seq=cover-rm-tianpin&orientation=portrait',
    intro: '每一份甜点背后，都藏着一个待解的谜题。甜品侦探一边享用精致点心，一边抽丝剥茧，破解温柔而离奇的案件。',
  },
];

export const allComics: Comic[] = [...guomanComics, ...rimanComics];

export const popularComics: Comic[] = [
  allComics.find((c) => c.id === 'shanhai')!,
  allComics.find((c) => c.id === 'xia')!,
  allComics.find((c) => c.id === 'jixie')!,
  allComics.find((c) => c.id === 'jianzhou')!,
  allComics.find((c) => c.id === 'yunhai')!,
  allComics.find((c) => c.id === 'shenye')!,
];